import { DOCUMENTS_LOADING } from '../actions/index';

export default ( state = false, action ) => {
	switch ( action.type ) {
		case DOCUMENTS_LOADING:
			return action.payload;
	}
	return state;
}